import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { KpiCardComponent } from '../../components/kpi-card/kpi-card.component';
import { TestKpis } from '../../models/dashboard.model';

@Component({
  selector: 'app-testmanager-kpis',
  imports: [TranslatePipe, KpiCardComponent],
  templateUrl: './testmanager-kpis.component.html',
  styleUrl: './testmanager-kpis.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TestmanagerKpisComponent {
  kpis = input.required<TestKpis>();

  protected readonly passRateValue = computed(() => this.kpis().passRate.value.toFixed(1));
}
